import { FC } from 'react';
import { Grid, TextField, FormControl, FormHelperText } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { IVendorBill } from '@/types';
import { useLoadStatusCheck } from '@/hooks/useLoadStatusCheck';
import CustomerSelect from './CustomerSelect';
import { useLoadExistBillCheck } from '@/hooks/useLoadExistBillCheck';
import { useAppSelector } from '@/redux/store';
interface HeaderSectionProps {
  initialData: IVendorBill | null,
  openCustomerModal:()=>void
}
const HeaderSection: FC<HeaderSectionProps> = ({ initialData,openCustomerModal }) => {
  const isRepairCompany= useAppSelector((state)=>state.user.currentCompanyDetails.type==="REPAIR SHOP")
  const form = useFormContext<IVendorBill>()
  const billNumber = useWatch({ control: form.control, name: 'BillNumber' });
  const loadNumber = useWatch({ control: form.control, name: 'loadNumber' });
  const loadId = useWatch({ control: form.control, name: 'loadId' });

  const { isAvailable, isLoading, loadStatusError:InvoiceError } = useLoadStatusCheck({
    documentNumber: billNumber,
    documentType: 'bill',
    initialData,
    apiMethod: 'checkAccountBillNumberExist'
  });
  const { isAvailable:isLoadAvaible, isLoading:isLoadLoading, loadStatusError } = useLoadExistBillCheck({
    documentNumber: loadNumber || "",
    initialData,
    onDocumentCheckSuccess: (response: any) => {
      // Handle successful document check
      if (!response?.load) {
        // Reset vendor fields when no load found
        form.setValue("vendorId", "");
        form.setValue("name", "");
        form.setValue("expense", []);
      }
    },
    onDocumentCheckError: (error: any) => {
      // Handle document check error
      form.setValue("expense", []);
      form.setValue("loadId", "");
      form.setValue("loadAmount", 0);
      form.setValue("vendorId", "");
    },
    onDocumentNotFound: () => {
      // Handle when no document is found
      form.setValue("vendorId", "");
      form.setValue("name", "");
    },
  });
  console.log("form.errors",form.formState.errors)
  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        {/* Bill Number */}
        <Grid item xs={12} md={4}>
          <FormControl size='small' fullWidth error={!!form.formState.errors.BillNumber}>
            <TextField size='small'
              fullWidth
              label="Bill Number"
              {...form.register('BillNumber')}
              value={billNumber || ""}
              error={!!form.formState.errors.BillNumber || Boolean(billNumber) && !isAvailable}
              helperText={
                isLoading
                  ? "Checking availability..."
                  : form.formState.errors.BillNumber?.message ||
                  InvoiceError ||
                  (Boolean(billNumber) && !isAvailable ? "Bill Number Already Exists" :Boolean(billNumber) && "Bill Number is Available")
              }
              InputLabelProps={{ shrink: true }}
              InputProps={{
                readOnly: !!initialData?._id,
              }}
            />
          </FormControl>
        </Grid>

        {/* Load Number */}
      { ! isRepairCompany &&      <Grid item xs={12} md={4}>
          <FormControl size='small' fullWidth error={!!form.formState.errors.loadNumber}>
            <TextField size='small'
              fullWidth
              label="Load Number"
              {...form.register('loadNumber')}
              value={loadNumber || ""}
              error={!!form.formState.errors.loadNumber || Boolean(loadNumber) && !isLoadAvaible}
              helperText={
                isLoadLoading
                  ? "Checking load availability..."
                  : form.formState.errors.loadNumber?.message ||
                  loadStatusError ||
                  (Boolean(loadNumber) && !isLoadAvaible ? "Load Number Not Available" : Boolean(loadNumber) && "Load Number is Available")
              }
              InputLabelProps={{ shrink: true }}
              InputProps={{
                readOnly: !!initialData?._id,
              }}
            />
          </FormControl>
        </Grid>} 
    

        {/* Vendor Name */}
        <Grid item xs={12} md={4}>
          {
            !loadId ? <CustomerSelect openCustomerModal={openCustomerModal} /> : <FormControl size='small' fullWidth>
              <TextField size='small'
                fullWidth
                label="Carrier Name"
                value={form.watch("name") || ""}
                disabled
                error={!!form.formState.errors.vendorId}
                helperText={form.formState.errors.vendorId?.message}
              />
            </FormControl>
          }
        </Grid>

        <Grid item xs={12} md={12}>
          <FormControl size='small' fullWidth error={!!form.formState.errors.address}>
            <TextField size='small'
              fullWidth
              label="Billing Address"
              multiline
              rows={2.5}
              error={!!form.formState.errors.address}
              {...form.register('address')}
              placeholder="Enter billing address"
              InputLabelProps={{ shrink: true }}
            />
            {form.formState.errors.address && (
              <FormHelperText error={!!form.formState.errors.address}>{form?.formState?.errors?.address?.message}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HeaderSection;
